import {
    StrollerProductPhotoState,
    StrollersProductPhotosState,
    initialStrollerProductPhotoState,
    initialStrollersProductPhotosState,
} from "@/mk2/apps/strollers/containers/StrollerProductPhoto/StrollerProductPhoto.reducers";
import { AppState } from "@/mk2/reducers";

export const getStrollerProductPhotoState = (
    state: AppState,
    strollerSlug: string,
    strollerVariantId: number | null,
): StrollerProductPhotoState =>
    getStrollerProductPhotoPagesState(state).pages[`${strollerSlug}/${strollerVariantId}`] ||
    initialStrollerProductPhotoState;

export const getStrollerProductPhotoPagesState = (state: AppState): StrollersProductPhotosState =>
    state.containers.strollers.strollersProductPhoto || initialStrollersProductPhotosState;
